"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateVirtualBackgroundUpload = validateVirtualBackgroundUpload;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _uploads = require("../utils/uploads");
var _sourceFileHelper = require("./sourceFileHelper");
/**
 * Validates a virtual background file upload.
 * @param {File} file - The file to upload.
 * @param {number} fileCount - The number of files being uploaded.
 * @returns {Promise<string[]>} A promise that resolves to an array of error messages,
 *  or an empty array if valid.
 */
function validateVirtualBackgroundUpload(_x, _x2) {
  return _validateVirtualBackgroundUpload.apply(this, arguments);
}
function _validateVirtualBackgroundUpload() {
  _validateVirtualBackgroundUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, fileCount) {
    var errors;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          errors = [];
          _context.next = 3;
          return (0, _uploads.validateBackgroundUpload)(file, fileCount);
        case 3:
          errors = _context.sent;
          if ((0, _sourceFileHelper.getFileExtension)(file.name) === '.gif') {
            errors.push('File type not supported');
          }
          return _context.abrupt("return", errors);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _validateVirtualBackgroundUpload.apply(this, arguments);
}